import { NavigationBody } from './NavigationBody';
import { NavigationButton } from './NavigationButton';
import { NavigationCollapse } from './NavigationCollapse';
import { NavigationExpandedOnly } from './NavigationExpandedOnly';
import { NavigationExternalLink } from './NavigationExternalLink';
import { NavigationFooter } from './NavigationFooter';
import { NavigationLink } from './NavigationLink';
import { NavigationLogo } from './NavigationLogo';
import { NavigationRoot } from './NavigationRoot';
import { NavigationTitle } from './NavigationTitle';

export const Navigation = {
  Root: NavigationRoot,
  Body: NavigationBody,
  Footer: NavigationFooter,
  Title: NavigationTitle,
  Link: NavigationLink,
  ExternalLink: NavigationExternalLink,
  Collapse: NavigationCollapse,
  Logo: NavigationLogo,
  Button: NavigationButton,
  ExpandedOnly: NavigationExpandedOnly,
};
